var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Add from "./Add";
import Ajustes from "./Ajustes";
import AlertOutline from "./AlertOutline";
import Alert from "./Alert";
import Ambiente from "./Ambiente";
import Arrow from "./Arrow";
import Back from "./Back";
import Background from "./Background";
import Background2 from "./Background2";
import Box from "./Box";
import Caja from "./Caja";
import Carrito from "./Carrito";
import Check from './Check';
import Card from "./Card";
import Cheque from "./Cheque";
import Close from "./Close";
import Cerrar from "./Cerrar";
import Delete from "./Delete";
import Edit from "./Edit";
import Egreso from "./Egreso";
import Engranaje from "./Engranaje";
import Entrenamiento from "./Entrenamiento";
import Evento from "./Evento";
import Excel from "./Excel";
import Eyes from "./Eyes";
import Favorito from "./Favorito";
import Favorito2 from "./Favorito2";
import Girl from "./Girl";
import Ingreso from "./Ingreso";
import Lock from "./Lock";
import LockOutline from "./LockOutline";
import Moon from "./Moon";
import Menu from "./Menu";
import Menu2 from "./Menu2";
import Money from "./Money";
import NoDelete from "./NoDelete";
import Off from "./Off";
import Paquete from "./Paquete";
import Parameter from "./Parameter";
import Profanity from "./Profanity";
import Reload from "./Reload";
import Reserve from "./Reserve";
import Salir from "./Salir";
import Search from "./Search";
import Servisofts from "./Servisofts";
import Sun from "./Sun";
import Tranfer from "./Tranfer";
import Traspaso from "./Traspaso";
import Usuarios from "./Usuarios";
import Wifi from "./Wifi";
import WifiDisconnect from "./WifiDisconnect";
import Svg from "./Svg";
var Icons = __assign({ Add: Add, Ajustes: Ajustes, AlertOutline: AlertOutline, Alert: Alert, Ambiente: Ambiente, Arrow: Arrow, Back: Back, Background: Background, Background2: Background2, Box: Box, Caja: Caja, Card: Card, Carrito: Carrito, Cerrar: Cerrar, Check: Check, Cheque: Cheque, Close: Close, Delete: Delete, Edit: Edit, Egreso: Egreso, Engranaje: Engranaje, Entrenamiento: Entrenamiento, Evento: Evento, Excel: Excel, Eyes: Eyes, Favorito: Favorito, Favorito2: Favorito2, Girl: Girl, Ingreso: Ingreso, Lock: Lock, LockOutline: LockOutline, Moon: Moon, Menu: Menu, Menu2: Menu2, Money: Money, NoDelete: NoDelete, Off: Off, Paquete: Paquete, Parameter: Parameter, Profanity: Profanity, Reload: Reload, Reserve: Reserve, Salir: Salir, Search: Search, Servisofts: Servisofts, Sun: Sun, Tranfer: Tranfer, Traspaso: Traspaso, Usuarios: Usuarios, "Icon2": Alert, Wifi: Wifi, WifiDisconnect: WifiDisconnect }, Svg);
export default Icons;
// Lo que viente antes del _ es el nombre de la imagen ejemplo: {name}_blue
export var IconsVariant = {
    "Alert": { fill: "#c31c37" },
    "Usuarios": { fill: "transparent" },
    "Usuarios_all": { fill: "#414D90" },
    "Usuarios_cliente": { fill: "#5E5F1B" },
    "Usuarios_ventas": { fill: "#67C0B9" },
    "Usuarios_proveedor": { fill: "#7A0724" },
    "Usuarios_entrenador": { fill: "#15161A" },
    "Usuarios_administrador": { fill: "#83848A" }
};
